import React from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, Image } from 'semantic-ui-react';

/**
 * HeaderAndPage - Reusable header layout component
 * 
 * Note: The UniversalMessageIcon is now rendered globally in Layout.jsx,
 * so it no longer needs to be managed per-page here.
 * 
 * @param {string} headerImage - Image source for the header
 * @param {string} headerText - Main header text
 * @param {string} subHeaderText - Subtitle text
 * @param {React.ReactNode} children - Content to render below header
 * @param {boolean} isCircular - Whether the header image should be circular
 * @param {React.ReactNode} toolbarComponent - Optional toolbar component to render after header
 * @returns {JSX.Element} HeaderAndPage component
 */
const HeaderAndPage = ({
  headerImage,
  headerText,
  subHeaderText,
  children,
  isCircular = true,
  toolbarComponent = null,
  doCenter = false
}) => {
  const location = useLocation();
  let containerClasses = "listContainer noMarginLeft";
  if (doCenter) {
    containerClasses = "listContainer centerContainer"
  }
  return (
    <div className={containerClasses}>
      {/*
       * 2026-04-21 (PROTOTYPE_UX_UPGRADE_SPEC §11 Phase A):
       *  - Removed position:absolute on the header image; it now lives in a real
       *    Grid column so it sits inline-left of the title instead of floating
       *    over adjacent content. Fixes the "icon error position" bug surfaced
       *    on the Literary Group Builder page.
       *  - Shrunk the header ↔ body gap from 20 + 20 = 40 px down to 4 px by
       *    reducing the outer marginBottom and the inner paddingTop. Pages that
       *    want extra breathing room add it themselves.
       */}
      <div style={{ marginTop: "30px", marginBottom: "4px" }}>
        <Grid>
          <Grid.Row verticalAlign="middle">
            <Grid.Column width={3}>
              <div className="img-with-gradienta" style={{ padding: "20px" }}>
                <Image
                  src={headerImage}
                  circular={isCircular}
                  style={{ width: "150px", height: "120px" }}
                />
              </div>
            </Grid.Column>
            <Grid.Column
              width={13}
              textAlign={doCenter ? "center" : "left"}
              verticalAlign="middle"
            >
              <span className="blgListItemTitle">{headerText}</span>
              <span className="blgListSubTitle">{subHeaderText}</span><br />
              <span style={{ fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
                Path: {location.pathname}
              </span>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {/* Toolbar component area */}
        {toolbarComponent && (
          <Grid style={{ marginTop: "4px", marginBottom: "4px" }}>
            <Grid.Row>
              <Grid.Column width={16}>
                {toolbarComponent}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
      </div>
      <div style={{ paddingTop: '4px' }} >
        {children}</div>

    </div>
  );
};

export default HeaderAndPage;
